import React from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import HelpIcon from '@mui/icons-material/Help';
import { CustomTooltipProps } from './../../view-models';

// const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} arrow classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.arrow}`]: {
//     color: theme.palette.common.black,
//   },
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.black,
//   },
// }));

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip arrow {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#000000',
    cursor: 'pointer',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    boxShadow: '0 0 20px 0 #444',
  },
}));

function TooltipComponent({ title, desc, link }: CustomTooltipProps) {
  return (
    <HtmlTooltip
      title={
        <React.Fragment>
          <Typography color="inherit">{title}</Typography>
          <em>{desc}</em>
          <br />
          <br />
          {link && (
            <>
              For more info click{' '}
              <a href={link} target="_blank">
                here
              </a>
            </>
          )}
        </React.Fragment>
      }
      placement="right"
    >
      <HelpIcon sx={{ fontSize: 15, cursor: 'pointer' }} />
    </HtmlTooltip>
  );
}

// export default withAITracking(reactPlugin, TooltipComponent, undefined, 'inline-tooltip');
export default TooltipComponent;
